module.exports = __webpack_public_path__ + "static/img/Lumen5-PrimaryLogo.d74af491.png";